export default __webpack_public_path__ + "static/media/Personalrat-Duisburg.27be33d4.mp4";